import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { SimplePlaceholder } from './simpleSidebarState';
import SimpleAgentsPage from '../components/SimpleAgents/SimpleAgentsPage';

const PAGES: Record<SimplePlaceholder, { title: string; line: string }> = {
  'action-items': { title: 'Action items', line: 'What needs you — drafts to publish, definitions to review, numbers to confirm — will be gathered here.' },
  agents: { title: 'Agents', line: 'The agents that answer your questions, and what each one did this week, will be shown here.' },
  impact: { title: 'Impact', line: 'How Stroma is used across the workspace — questions answered, by channel and outcome — will be shown here.' },
};

/** A destination of the simplified sidebar (#1503) whose page has not been built yet: its own ticket builds it. */
export default function SimplePlaceholderPage({ page }: { page: SimplePlaceholder }) {
  if (page === 'agents') return <SimpleAgentsPage />;   // #1517
  const { title, line } = PAGES[page];
  return <Box data-testid={`simple-placeholder-${page}`} sx={{ flex: 1, minHeight: 0, overflow: 'auto', bgcolor: 'var(--bg)' }}>
    <Box sx={{ maxWidth: 1080, mx: 'auto', px: { xs: 2, md: 4 }, pt: 4, pb: 6 }}>
      <Typography component="h1" sx={{ fontSize: 24, fontWeight: 600, letterSpacing: '-.01em', mb: 0.5 }}>{title}</Typography>
      <Typography sx={{ color: 'var(--ink-3)', fontSize: 13.5, maxWidth: '70ch' }}>{line} Coming soon.</Typography>
    </Box>
  </Box>;
}
